import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@material-ui/core/styles';

import Main from '../components/main';
import Socket from '../components/socket';
import { AppProvider } from '../providers/app';
import theme from '../theme';

const app = document.getElementById('main');
const root = createRoot(app);
root.render(
  <AppProvider>
    <ThemeProvider theme={theme}>
    <div>
      <Socket />
      <Main />
    </div>
    </ThemeProvider>
  </AppProvider>
);
